import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { OrigemPipeModule } from '../../pipes';

import { OrigemInputGroupComponent } from './origem-input-group.component';

@NgModule({
    imports: [
        SharedModule,
        OrigemPipeModule
    ],
    declarations: [
        OrigemInputGroupComponent
    ],
    exports: [
        OrigemInputGroupComponent
    ]
})
export class OrigemInputGroupModule { }
